export const environment = {
  production: false,
  ENV_NAME: 'Development Environment',
  BASE_URL: 'https://api.dgs.mosaic-dev.siemens-energy.cloud/',
  APP_URL: 'https://dgs.mosaic-dev.siemens-energy.cloud/',
  azuread: {
    clientId: 'f01d817e-8b33-46ff-8193-e5ff8e9c7c49',
    authority: 'https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477',
    redirectUri: 'https://dgs.mosaic-dev.siemens-energy.cloud/callback',
    postLogoutRedirectUri: '/'
  }
};
